import { Bugo } from '@shared/api/bugo/bugo.interface';

//* 실제 입력으로 사용하는 것
export enum MemberBugoSendFormInputsEnum {
  MournerText = 'mournerText',
  CoffinInShow = 'config.coffinInShow',
  CashAccountShow = 'cofing.cashAccountShow',
  PhoneNumber = 'phoneNumber',
}

export interface MemberBugoIFormInput {
  _id: string;
  bugo?: Bugo;
  bugoId?: string;
  mournerText?: string;
  memberId?: string;
  phoneNumber?: string;
  //* 이 상주의 부고장에서 숨길 member id 목록 (기본 [] = 전원 표시)
  hiddenMemberIds?: string[];
}

export interface MemberBugoIFormInputs {
  memberBugo: MemberBugoIFormInput[];
}

export const vacantMemberBugoInputForm = [
  {
    _id: '',
    [MemberBugoSendFormInputsEnum.MournerText]: '',
    [MemberBugoSendFormInputsEnum.PhoneNumber]: '',
  },
];
